import * as React from 'react';
import { Location } from 'history';
import SearchForm from './SearchForm';
import SearchResults from './SearchResults';
import { Advert, SearchQuery, SearchResult, Tag } from '../../models';
import { TagFilterGroup } from '../../containers/SearchPage';
import './style.css';

export interface SearchProps {
  advertSlotOne?: Array<Advert>;
  advertSlotTwo?: Array<Advert>;
  error: boolean;
  loading: boolean;
  location: Location;
  pageUrl: string;
  query: SearchQuery;
  searchableTags: Array<Tag>;
  searchResult?: SearchResult;
  tagFilterGroups: Array<TagFilterGroup>;
  onAddSearchTag: (tag: Tag) => void;
  onRemoveSearchTag: (tag: Tag) => void;
}

export interface SearchState {
  /* empty*/
}

export class Search extends React.Component<SearchProps, SearchState> {
  render() {
    const {
      advertSlotOne,
      advertSlotTwo,
      error,
      loading,
      pageUrl,
      query,
      searchableTags,
      searchResult,
      tagFilterGroups,
      onAddSearchTag,
      onRemoveSearchTag
    } = this.props;

    return (
      <main className="search-page" role="main">
        <SearchForm
          disabled={loading}
          query={query}
          searchableTags={searchableTags}
          tagFilterGroups={tagFilterGroups}
          onAddSearchTag={onAddSearchTag}
          onRemoveSearchTag={onRemoveSearchTag}
        />

        <h1 className="search-page-header">{this.getSearchTitle(query)}</h1>

        <SearchResults
          advertSlotOne={advertSlotOne}
          advertSlotTwo={advertSlotTwo}
          error={error}
          loading={loading}
          pageUrl={pageUrl}
          query={query}
          searchResult={searchResult}
        />
      </main>
    );
  }

  private getSearchTitle = (query: SearchQuery): string => {
    const SEARCH_TITLE = `Search Results`;

    const { tags } = query;

    if (!tags) {
      return SEARCH_TITLE;
    }

    if (tags.length === 1) {
      return `${SEARCH_TITLE}: ${tags[0].name}`;
    }

    return SEARCH_TITLE;
  };
}

export default Search;



// WEBPACK FOOTER //
// ./src/app/components/Search/index.tsx